import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GetAdminLogo } from "./adminLogin/httpServicesAdmin/adminApis";
// import logo from "../assets/img/Black logo - no background_page-0001.jpg";
import { useRecoilState, useRecoilValue } from "recoil";
import { adminLogoAtom } from "../../recoil/adminLogo";

const Sidebar = ({ slide, getBarClick }) => {
  const navigate = useNavigate();
  const [SlideState, setSlideState] = useState("");
  const adminLogo = useRecoilValue(adminLogoAtom);
  const [_, setAdminLogo] = useRecoilState(adminLogoAtom);
  const width = window.innerWidth;

  useEffect(() => {
    let adminToken = localStorage.getItem("sorise-token-admin");
    if (!adminToken) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    let adminToken = localStorage.getItem("sorise-token-admin");
    if (!adminToken) {
      navigate("/");
      return;
    }

    setSlideState(slide);
    getAdminLogo();
  }, []);

  const getAdminLogo = async () => {
    let { data } = await GetAdminLogo();
    if (!data?.error) {
      setAdminLogo(data?.results?.logo[0]?.image);
    }
  };

  const Logout = () => {
    localStorage.removeItem("sorise-token-admin");
    localStorage.removeItem("sorise-admin-data");
    navigate("/admin/login");
  };

  return (
    <div className="siderbar_section">
      <div className="siderbar_inner">
        <div className="sidebar_logo">
          <a>
            <img src={adminLogo} alt="Logo" />{" "}
          </a>
        </div>
        <div className="sidebar_menus pb-5">
          <ul className="list-unstyled ps-0 m-0">
            <li>
              <a
                className={
                  slide === "Dash"
                    ? "active text-decoration-none"
                    : " text-decoration-none"
                }
                onClick={() => navigate("/admin/dashboard")}
              >
                <i class="fas fa-home"></i>
                Dashboard
              </a>
            </li>
            <>
              <li>
                <a
                  className={
                    slide === "SM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/student-management")}
                >
                  <i className="fas fa-users" />
                  Student Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "TM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/teacher-management")}
                >
                  <i className="fas fa-chalkboard-teacher" />
                  Teacher Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "SubM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/subject-management")}
                >
                  <i className="fas fa-book" />
                  Subject Management
                </a>
              </li>

              <li>
                <a
                  className={
                    slide === "QPM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/question-paper-management")}
                >
                  <i className="fas fa-question" />
                  Question Paper Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "SPM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() =>
                    navigate("/admin/subscription-plan-management")
                  }
                >
                  <i className="fas fa-hand-holding-usd" />
                  Subscription Plan Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "Promo"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/promocode-management")}
                >
                  <i class="fa-solid fa-dollar-sign"></i>
                  Promo Code Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "PN"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/push-notification")}
                >
                  <i className="fas fa-comment-alt" />
                  Push Notification
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "MT"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/my-transaction")}
                >
                  <i className="fas fa-sync-alt" />
                  My Transactions{" "}
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "Noti"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/notification")}
                >
                  <i className="fas fa-bell" />
                  Notifications
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "HS"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/help-support")}
                >
                  <i className="fas fa-headset" />
                  Help &amp; Support Management
                </a>
              </li>
              <li>
                <a
                  className={
                    slide === "CM"
                      ? "active text-decoration-none"
                      : " text-decoration-none"
                  }
                  onClick={() => navigate("/admin/content-management-system")}
                >
                  <i className="fas fa-edit" />
                  Content Management
                </a>
              </li>
            </>

            <li>
              <a className=" text-decoration-none" onClick={() => Logout()}>
                <i class="fas fa-sign-out-alt"></i>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
